"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionLockRpcLocal = void 0;
const utils_1 = require("@streamr/utils");
const DhtRpc_1 = require("../../generated/packages/dht/protos/DhtRpc");
const ConnectionManager_1 = require("./ConnectionManager");
const identifiers_1 = require("../identifiers");
const logger = new utils_1.Logger(module);
class ConnectionLockRpcLocal {
    options;
    constructor(options) {
        this.options = options;
    }
    async lockRequest(lockRequest, context) {
        const senderPeerDescriptor = context.incomingSourceDescriptor;
        if ((0, identifiers_1.areEqualPeerDescriptors)(senderPeerDescriptor, this.options.getLocalPeerDescriptor())) {
            const response = {
                accepted: false
            };
            return response;
        }
        const remoteNodeId = (0, identifiers_1.toNodeId)(senderPeerDescriptor);
        this.options.addRemoteLocked(remoteNodeId, lockRequest.lockId);
        const response = {
            accepted: true
        };
        return response;
    }
    async unlockRequest(unlockRequest, context) {
        const senderPeerDescriptor = context.incomingSourceDescriptor;
        const nodeId = (0, identifiers_1.toNodeId)(senderPeerDescriptor);
        this.options.removeRemoteLocked(nodeId, unlockRequest.lockId);
        return {};
    }
    async gracefulDisconnect(disconnectNotice, context) {
        const senderPeerDescriptor = context.incomingSourceDescriptor;
        logger.trace((0, ConnectionManager_1.getNodeIdOrUnknownFromPeerDescriptor)(senderPeerDescriptor) + ' received gracefulDisconnect notice');
        if (disconnectNotice.disconnectMode === DhtRpc_1.DisconnectMode.LEAVING) {
            await this.options.closeConnection(senderPeerDescriptor, true, 'graceful leave notified');
        }
        else {
            await this.options.closeConnection(senderPeerDescriptor, false, 'graceful disconnect notified');
        }
        return {};
    }
    async setPrivate(request, context) {
        const senderPeerDescriptor = context.incomingSourceDescriptor;
        const senderId = (0, identifiers_1.toNodeId)(senderPeerDescriptor);
        this.options.setPrivate(senderId, request.isPrivate);
        return {};
    }
}
exports.ConnectionLockRpcLocal = ConnectionLockRpcLocal;
//# sourceMappingURL=ConnectionLockRpcLocal.js.map